import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { LocaleSwitch } from 'containers/misc'
import { MaterialModal } from 'components/layout'
import { Note } from 'components/misc'

export default class SettingsModal extends Component {
  static propTypes = {
    modalId: PropTypes.string,
    isInIac: PropTypes.bool,
    isRegLocEnabled: PropTypes.bool,
  }

  render() {
    const { modalId, isInIac, isRegLocEnabled } = this.props
    const showMessage = isInIac || isRegLocEnabled

    return (
      <MaterialModal.Body
        id={modalId}
        title="Settings"
        titleKey="moduleTitle.settings"
      >
        <MaterialModal.Content>
          {!showMessage && <LocaleSwitch labelless={false} />}
          {showMessage && (
            <Note>
              <FormattedMessage
                id="label.language_selection_is_disabled_for_iac"
                defaultMessage="Language selection is disabled for IAC's"
              />
            </Note>
          )}
        </MaterialModal.Content>
      </MaterialModal.Body>
    )
  }
}
